import { render, staticRenderFns } from "./CurrencyExchangesModal.vue?vue&type=template&id=56c4ea1e&scoped=true"
import script from "./CurrencyExchangesModal.vue?vue&type=script&lang=js"
export * from "./CurrencyExchangesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4ea1e",
  null
  
)

export default component.exports